/* eslint-disable import/prefer-default-export */
export const COLORS = {
    /** * GRAYS ** */

    neutral000: '#F7F9FA', //  for container borders and dividers
    neutral100: '#D9DADB', // for disabled text and buttons
    neutral200: '#CCCCCC', // for disabled text and buttons
    neutral300: '#727273', // for placeholder input text
    neutral700: '#424242', // for secondary text and icons
    neutral900: '#1C1C1C', // for default text color

    /** * COLORS ** */

    white: '#FFFFFF',
    primary300: '#0277BD', // for primary action components
    primary700: '#01579B', // for primary hover/focus -- rebrand: #521674
    overlay: 'rgba(0, 0, 0, 0.88)', // for use bg under dialogs and modals
    banana300: '#FECC00', // for  “new” tags
    banana700: '#FFB300',
    success300: '#20A85F', // for icons and shapes
    success700: '#187F48', // for accessible text
    danger300: '#E82E41', // for icons
    danger700: '#D32F2F', // for accessible text

    /** * PASTELS ** */

    pastelPrimary300: '#F2F8FB', // for active icon background  --  rebrand: #EBE0F1
    pastelDanger300: '#F9E0E0', // for error state background -- rebrand: #F9E0E0
    pastelSecondary100: '#DBF4F4',
    pastelSecondary700: '#CCE4F2',
    pastelBanana300: '#FFF5CC',
};

// TODO: IF YOU SEE ANY OF THE HEX BELOW IN THE REPO PLEASE UPDATE
//     '#FF0000' - can reassign to danger-300
//     '#4b4b4b' - can reassign to neutral-900
//     '#F3F8FA' -can reassign to pastel-secondary-100
//     '#3179AD' - reassign to primary-300
//     '#F5FAF7' - “pastel-success-100’
//     '#41A667' - reassign to success-300
//     '#979799' - reassign to neutral-700
//     '#656566' - reassign to neutral-700
//     '#0084d1' - reassign to primary-300
//     '#e56969' - where is this being used? We normally don’t use pink
//     '#DEEBFF' -reassign to pastel-secondary-100
//     '#eeeeee' -reassign to neutral-000
//     '#EDEDEF' - reassign to neutral-000
//     '#F3F8FC' - reassign to neutral-000
//     '#1E77BD' - reassign to primary-300
